import { IconEdit as TablerIconEdit } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconEdit = /*#__PURE__*/ createOutlineIcon(TablerIconEdit, 'IconEdit');
